import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import { MovieProvider } from './context/MovieContext';
import Navbar from './components/Navbar';
import NotificationBar from './components/NotificationBar';
import HomePage from './pages/HomePage';
import MovieDetailPage from './pages/MovieDetailPage';
import SearchPage from './pages/SearchPage';
import MoviesPage from './pages/MoviesPage';
import WatchlistPage from './pages/WatchlistPage';
import AuthPage from './pages/AuthPage';
import AdminPage from './pages/AdminPage';
import ProfilePage from './pages/ProfilePage';
import RequestPage from './pages/RequestPage';
import SeriesPage from './pages/SeriesPage';
import Loader from './components/Loader';

const AdminRoute = ({ children }) => {
  const { user, isAdmin, loading } = useAuth();
  if (loading) return <Loader full />;
  if (!user)    return <Navigate to="/auth" replace />;
  if (!isAdmin) return <Navigate to="/" replace />;
  return children;
};

const PrivateRoute = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return <Loader full />;
  if (!user)   return <Navigate to="/auth" replace />;
  return children;
};

const GuestRoute = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return <Loader full />;
  if (user)    return <Navigate to="/" replace />;
  return children;
};

const AppRoutes = () => (
  <>
    <Navbar />
    <NotificationBar />
    <Routes>
      <Route path="/"           element={<HomePage />} />
      <Route path="/movie/:id"  element={<MovieDetailPage />} />
      <Route path="/series/:id" element={<SeriesPage />} />
      <Route path="/search"     element={<SearchPage />} />
      <Route path="/movies"     element={<MoviesPage />} />
      <Route path="/watchlist"  element={<WatchlistPage />} />
      <Route path="/request"    element={<PrivateRoute><RequestPage /></PrivateRoute>} />
      <Route path="/profile"    element={<PrivateRoute><ProfilePage /></PrivateRoute>} />
      <Route path="/auth"       element={<GuestRoute><AuthPage /></GuestRoute>} />
      <Route path="/admin"      element={<AdminRoute><AdminPage /></AdminRoute>} />
      <Route path="*"           element={<Navigate to="/" replace />} />
    </Routes>
  </>
);

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <MovieProvider>
          <AppRoutes />
        </MovieProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}
